<template>
	<div>
		<!-- <CreateNewCase :create_new_case.sync="modals.create_new_case" /> -->
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col lg="6" cols="7">
					<p class="text-muted">Credit Loan Case</p>
					<h2 class="text-xl d-inline-block mb-0">Case</h2>
				</b-col>
				<!-- <b-col cols="6" class="text-right">
					<el-button type="primary"  @click="modals.create_new_case = true">Create New</el-button>
				</b-col> -->
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<CaseTable />
		</b-container>
	</div>
</template>
<script>
import { Button } from 'element-ui'
// import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import CaseTable from '@/views/CreditLoanCase/CaseTable'
// import CreateNewCase from '@/views/CreditLoanCase/CaseModals/CaseTable/CreateNewCase'

export default {
	components: {
		// RouteBreadCrumb,
		CaseTable,
		// CreateNewCase,
		[Button.name]: Button,
	},
	data() {
		return {
			backButton: false,
			isTableLoading: true,
			modals: {
				create_new_case: false
			}
		}
	}
}
</script>